import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center white--text mb-4"},[_c(VRow,{attrs:{"justify":"center"}},[_c(VImg,{attrs:{"max-height":"150","max-width":"250","src":"/lessadmin.png"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }